<template lang='pug'>
  div(class='')
    div(class='u-bg-primary u-flex u-flex-wrap o-container u-pt5' v-if='showInfo')
      figure(class='u-px2 u-2/12@laptop u-6/12@tablet u-mb4 u-12/12 u-m0'  data-aos="fade-up")
        img(src='/images/logo_white.png'  style='max-height:50px')

      div(class='u-px2 u-2/12@laptop u-4/12@tablet u-mb4 u-12/12'  data-aos="fade-up")
        p(class='u-white u-fw-s-bold u-mt0') La Empresa
        ul(class='u-m0 u-pl0 u-list-none u-color-text')
          li(class='u-mb2')
            router-link(:to="{ name: 'Home'}" exact class='u-decoration-none u-color-text') Inicio
          li(class='u-mb2')
            router-link(:to="{ name: 'Services'}" class='u-decoration-none u-color-text') Servicios
          li(class='u-mb2')
            router-link(:to="{ name: 'About'}" class='u-decoration-none u-color-text') Nosotros
          li(class='u-mb2')
            router-link(:to="{ name: 'Posts'}" class='u-decoration-none u-color-text') Noticias
          li(class='u-mb2')
            router-link(:to="{ name: 'Contact'}" class='u-decoration-none u-color-text') Contáctanos


      div(class='u-px2 u-2/12@laptop u-4/12@tablet u-mb4 u-12/12'  data-aos="fade-up")
        p(class='u-white u-fw-s-bold u-mt0') Trabaja con nosotros
        ul(class='u-m0 u-pl0 u-list-none u-color-text')
          li(class='u-mb2')
            router-link(:to="{ name: 'Driver'}" class='u-decoration-none u-color-text') Conductor Pavill
          li(class='u-mb3 u-border-bottom u-pb3 u-border-text')
            router-link(:to="{ name: 'Operator'}" class='u-decoration-none u-color-text') Operadora

          li(class='u-mb2')
            router-link(:to="{ name: 'Complaints'}" class='u-decoration-none u-color-text')
              i(class='u-icon u-mr2') book
              span Libro de Reclamaciones

      div(class='u-px2 u-3/12@laptop u-4/12@tablet u-mb4 u-12/12'  data-aos="fade-up")
        p(class='u-white u-fw-s-bold u-mt0') App
        ul(class='u-m0 u-pl0 u-list-none u-color-text')
          li(class='u-mb2')
            router-link(:to="{ name: 'App'}" class='u-decoration-none u-color-text') Descargar APP
          li(class='u-mb2')
            router-link(:to="{ name: 'Terms'}" class='u-decoration-none u-color-text') Terminos y condiciones de la APP

      div(class='u-px2 u-3/12@laptop u-4/12@tablet u-mb4 u-12/12'  data-aos="fade-up")
        p(class='u-white u-fw-s-bold u-mt0 u-fz-h4') Pide un {{company.name}}
        ul(class='u-m0 u-pl0 u-list-none u-color-text')
          li(class='u-mb2 u-fw-s-bold' v-if='company.phone')
            i(class='u-icon u-color-secondary u-mr2') phone
            span {{company.phone}}
          li(class='u-mb2 u-fw-s-bold' v-if='company.cellphone')
            i(class='u-icon u-color-secondary u-mr2') cellphone
            span {{company.cellphone}}
          li(class='u-mb2 u-fw-s-bold' v-if='company.email')
            i(class='u-icon u-color-secondary u-mr2') message
            span {{company.email}}

    footer( class='o-container u-bg-primary u-center u-py3 u-fz-h6 u-fw-light u-color-text')
      ul(class='u-mt0 u-pl0 u-list-none  u-flex u-justify-center u-mb3' v-if='showInfo')
        a(target='_blank' class='c-btn-share c-btn-share--facebook', :href='company.facebookPage' v-if='company.facebookPage')
          i(class='u-icon') facebook
        a(target='_blank' class='c-btn-share c-btn-share--linkedin', :href='company.linkedinPage' v-if='company.linkedinPage')
          i(class='u-icon') linkedin
        a(target='_blank' class='c-btn-share c-btn-share--instagram', :href='company.instagramPage' v-if='company.instagramPage')
          i(class='u-icon') instagram
        a(target='_blank' class='c-btn-share c-btn-share--google', :href='company.youtubePage', v-if='company.youtubePage')
          i(class='u-icon') youtube
        a(target='_blank' class='c-btn-share c-btn-share--soundcloud', :href='company.soundcloudPage' v-if='company.soundcloudPage')
          i(class='u-icon') soundcloud
        a(target='_blank' class='c-btn-share c-btn-share--vimeo', :href='company.vimeoPage', v-if='company.vimeoPage')
          i(class='u-icon') vimeo
      span(class='u-color-text' ) Copyright &copy {{ date.getFullYear() }} {{ company.name }}. Todos los derechos reservados. Desarrollado por&nbsp;
        a(href='https://noveltie.la/' target='_blank' class='u-color-text u-decoration-none u-fw-s-bold') Noveltie
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'AppFooter',
    props: {
      showInfo: {
        type: Boolean,
        default: true
      }
    },

    data () {
      return {
        date: new Date(),
        isMobile: false
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      }),

      faceWeb () {
        return `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2F${this.company.facebookPage}&tabs=timeline&width=300&height=72&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
      }
    },

    mounted () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/AppFooter.vue